import React from 'react'
import { StaticQuery, Link } from 'gatsby'
import _ from 'lodash'
import Img from 'gatsby-image'
import styled from 'styled-components'
import SEO from '../components/seo'

const BlogContent = styled.div`
  margin: 3em 0;

  h1 {
    margin: 3em 0;
    font-weight: bold;
  }

  div {
    max-width: 340px;
  }

  a {
    text-transform: uppercase;
    display: block;
  }
`

const Personal = () => (
  <StaticQuery
    query={graphql`
      query ClentNavigationQuery {
        allPrismicClient(sort: {fields: data___title___text, order: ASC}) {
          edges {
            node {
              data {
                title {
                text
              }
              }
            }
          }
        }
      }
    `}
    render={data => (
      <>
        <SEO
          title="client"
          keywords={[
            `client photography`,
            `nike`,
            `nike snkrs`,
            `flatbush zombies`,
            `adidas`,
            `gmc lebron james`,
          ]}
        />
        <BlogContent>
          <h1>Client /</h1>

          {data.allPrismicClient.edges.map(({ node }) => (
            <div>
              <Link to={`/${_.kebabCase(node.data.title.text)}`}>{node.data.title.text} </Link>
            </div>
          ))}
        </BlogContent>
      </>
    )}
  />
)

export default Personal
